import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencyBar() {
  return <div className="bg-brand-creamAlt py-6 px-4 text-center border-y-2 border-brand-orange" data-id="element-283">
      <p className="font-display font-bold orange-text text-base md:text-2xl uppercase tracking-wide mb-3 animate-pulse" data-id="element-284">
        ⏰ El Precio de Lanzamiento Termina En:
      </p>
      <CountdownTimer data-id="element-285" />
      <p className="text-xs md:text-sm text-brand-mute font-bold uppercase tracking-widest mt-3" data-id="element-286">
        Después sube el precio y los bonos no estarán incluidos
      </p>
    </div>;
}